<template>
  <section class="box carousel">
    <div class="carousel-wrapper">
      <v-skeleton-loader
        v-if="loading"
        type="image"
        class="skeleton-loader"
      ></v-skeleton-loader>

      <v-carousel
        v-else
        :show-arrows="true"
        :hide-delimiter-background="true"
        :hide-delimiters="true"
        :continuous="true"
        :interval="7000"
        :height="calcCarouselheight"
        :cycle="true"
      >
        <template v-slot:prev="{ props }">
          <v-btn
            icon="mdi-chevron-right"
            class="btn-right"
            variant="elevated"
            @click.stop="props.onClick"
          ></v-btn>
        </template>
        <template v-slot:next="{ props }">
          <v-btn
            icon="mdi-chevron-left"
            class="btn-left"
            variant="elevated"
            @click.stop="props.onClick"
          ></v-btn>
        </template>
        <v-carousel-item
          v-for="image in carouselImages"
          :key="image.promo"
          eager
        >
          <div
            @click="openPromotionLink(image)"
            class="carousel-continer cursor-pointer"
          >
            <v-img cover class="image-carousel" eager :src="imgUrl(image)">
              <div class="content-continer">
                <h2>{{ image.tilte }}</h2>
                <p class="multiline-text">{{ image.contant }}</p>
              </div>
            </v-img>
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { getImageUrl } from "../../utilities";

export default {
  props: {
    carouselImages: {
      type: Array,
      default: () => [{}],
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    carouselImages: {
      immediate: true,
      handler(newImages) {
        if (newImages && newImages.length > 0) {
          this.preloadImages(newImages);
        }
      },
    },
  },
  methods: {
    imgUrl(promotion) {
      return getImageUrl(promotion?.imgUrl, 500);
    },
    openPromotionLink(image) {
      window.open(image.url, "_blank");
    },
    preloadImages(images) {
      this.loading = true;
      const imagePromises = images.map((image) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = reject;
          img.src = image.imgUrl;
        });
      });

      Promise.all(imagePromises)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
    }),
    calcCarouselheight() {
      if (this.isDesktop) {
        return "480px";
      } else if (this.isLaptop) {
        return "360px";
      } else if (this.isTablet) {
        return "220px";
      } else {
        return "200px";
      }
    },
  },
};
</script>

<style lang="scss">
.skeleton-loader {
  .v-skeleton-loader__image {
    height: v-bind(calcCarouselheight) !important;
  }
}
</style>

<style scoped lang="scss">
.carousel {
  overflow: hidden !important;
}
.btn-left,
.btn-right {
  background: #ffffffb8;
  box-shadow: unset !important;
}
.btn-right {
  left: 10px;
}
.btn-left {
  right: 10px;
}
.carousel-continer {
  display: flex;
  justify-content: space-between;
}
.carousel-overlay {
  position: absolute;
  height: 100%;
  z-index: 1;
  width: 100%;
  border-radius: 10px;
}
.content-continer {
  text-align: start;
  padding: 70px 80px;
  width: 50%;
  h2 {
    font-size: 55px;
    color: black;
  }
  p {
    color: black;
    font-size: 18px;
  }
}

.v-carousel {
  border-radius: 10px;
  overflow: hidden;
}
.image-carousel {
  // float: left;
  object-fit: cover;
}
.multiline-text {
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: break-word;
}

.carousel-wrapper {
  * {
    overflow: unset !important;
  }
  position: relative;
  // margin-left: 150px;
  // margin-right: 150px;
  margin-top: 32px;
  z-index: 2;
}
.isTablet,
.isMobile {
  .carousel-wrapper {
    margin: unset;
  }
  section {
    &.box {
      padding: 0 !important;
    }
  }
  .content-continer {
    padding: 25px;
    width: 85% !important;
    min-height: 200px;
    h2 {
      font-size: 35px;
    }
    p {
      font-size: 18px;
      color: $DeepGray;
    }
  }
  .btn-left,
  .btn-right {
    height: unset !important;
    width: unset !important;
  }
  .btn-right {
    left: 20px;
  }
  .btn-left {
    right: 20px;
  }
}
@media only screen and (max-width: 1024px) {
  // .carousel-wrapper {
  //   margin-left: 20px;
  //   margin-right: 20px;
  // }
  // h3 {
  //   margin-top: 30px;
  // }
  // img {
  //   height: 200px;
  // }
}

.skeleton-loader {
  border-radius: 10px;
  overflow: hidden;
}
</style>
